import PropTypes from 'prop-types';
import Image from 'next/image';
import breakPoints from 'helpers/Styles';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import SoldOutLabel from 'components/SoldOutLabel/index-rts';
import cn from 'classnames';
import ProductPerformanceTips from '../../containers/Product/ProductToolTip/ProductTips';
import Progress_bar from 'components/LineBar/progressBar';

const ProductCardClearance = ({ item, buttonLabel, fixedPrice }) => {
  const [showTitle, setShowTitle] = useState(false);

  if (!item.product) return '';
  const productTags = item?.product?.tags.split(',');
  // console.log('productTags :::', productTags)
  
  const altText = item.product.images[0].alt ? item.product.images[0].alt : item.product.title;

  const [tooltip, setTooltip] = useState(-1);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const performanceTags = productTags?.filter((tag) =>
    tag.trim().startsWith('performance:'),
  );
  const specificationTags = productTags.filter((item) =>
    item.trim().startsWith('specifications:'),
  );
  const sameDayShipping = productTags.filter((item) =>
    item.trim().startsWith('shipping:'),
  );
  const sameDayShipAvab =
    sameDayShipping.length > 0 && sameDayShipping[0].split(':')[1];
  let existSpec = [];
  let orderArr = [];
  const existStrArr = ['cpu', 'cooler', 'motherboard', 'graphicscard', 'ram', 'storage', 'power'];
  if (specificationTags?.length > 0)
    specificationTags.map((item, tag) => {
      let indexCheck = typeof item.split(':')[1] !== 'undefined' ?  item.split(':')[1].replace(/-/g, ' ') : '';
      let title = typeof item.split(':')[2] !== 'undefined' ? item.split(':')[2].replace(/-/g, '').replace(/ /g, '') : '';

      let description = typeof item.split(':')[3] !== 'undefined' ? item.split(':')[3].replace(/-/g, ' ')  : '';
      if (!existSpec.includes(parseInt(indexCheck)) && existStrArr.includes(title.toLowerCase())) {
        existSpec.push(parseInt(indexCheck));
        orderArr[existStrArr.indexOf(title.toLowerCase())] = {
          title,
          description
        }
      }
    });
  const renderPngIcon = (featureType) => {
    if (!featureType) return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-default.png?v=1713860983';
    if (featureType) {
      let type = featureType && featureType.replace(/ /g, '').replace(/-/g, '').toLowerCase();
      if (type == 'graphicscard' || type == 'graphics-card') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/GPU.png?v=1713810282';
      if (type == 'cpu' || type == 'processor') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/CPU.png?v=1713810369';
      if (type == 'storage') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-storage_1.png?v=1713810191';
      if (type == 'case') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/CHASSIS.png?v=1713808436';
      if (type == 'ram') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/RAM.png?v=1713810338';
      if (type == 'motherboard') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/MOTHERBOARD.png?v=1713810404';
      if (type == 'cooler' || type == 'coolingsystem') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-cooling.png?v=1713808156';
      if (type == 'fans') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-cooling.png?v=1713808156';
      if (type == 'power') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/POWER_SUPPLY.png?v=1713810509';
      if (type == 'operatingsystem') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/SCREEN_6bed68ff-4dbc-488e-a707-41a734a36d2b.png?v=1714570565';
      if (type == 'wireless') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/WIFI.png?v=1713860550';
      if (type == 'cablesleeves') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/CABLE_SLEEVE.png?v=1714570469';
      if (type == 'warranty') return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/WARRENTY.png?v=1714570437';
      return 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-default.png?v=1713860983';
    }
  };

  const handleOpenModal = (idx) => {
    setIsTooltipOpen(true);
    setTooltip(idx);
  };

  const [imageUrl, setImageUrl] = useState(
    item?.product?.images[0]?.src || 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/product.png?v=1713944259',
  );
  const handleHoverOn = () => {
    if (item?.product?.images[1]?.src) {
      setImageUrl(item.product.images[1].src);
    }
  };
  const handleHoverLeave = () => {
    setImageUrl(
      item?.product?.images[0]?.src || 'item.product.images[0]?.src',
    );
  };

  useEffect(() => {
    if(typeof item.product.images[0]?.src !== 'undefined')
    setImageUrl(item?.product?.images[0]?.src);
  }, [item]);

  const handleCloseModal = () => {
    setIsTooltipOpen(false);
  };
  return (
    <div>
      <Link href={`/products/${item.product.handle}`  || '#'}>
        <a href={`/products/${item.product.handle}`  || '#'}>
          <div className="product_card">
            <div className="image_container">
              <Link href={`/products/${item.product.handle}`  || '#'}>
                <a href={`/products/${item.product.handle}`  || '#'}>
                  <div
                    className={
                      item.product.variants?.[0]?.inventory_quantity < 1
                        ? 'image-sold-out'
                        : ''
                    }
                  >
                    <Image
                      src={imageUrl || 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/product.png?v=1713944259'}
                      alt={altText}
                      width={500}
                      height={550}
                    />
                  </div>
                </a>
              </Link>
              {item.product.variants?.[0]?.inventory_quantity < 1 && (
                <SoldOutLabel />
              )}
            </div>
            <p className="product_title">{item.product.title.split('/')[0]}</p>
            <div className="price_container">
              {item?.product?.variants[0]?.price && (
                <span className="product_pricing_price">
                  <span>&#36;</span>
                  {parseFloat(item.product.variants[0].price).toLocaleString()}
                </span>
              )}
              {item?.product?.variants[0]?.compare_at_price && (
                <span className="product_pricing_compare_price">
                  <strike>
                    <span>&#36;</span>
                    {parseFloat(
                      item.product.variants[0].compare_at_price
                    ).toLocaleString()}
                  </strike>
                </span>
              )}
            </div>
          </div>
        </a>
      </Link>
      <style jsx>
        {`
          .Storage {
            padding: 3px 7px 0 2px;
          }
          .image-container {
            position: inherit !important;
          }
          .product_card {
            width: 308px;
            flex: 1;
            position: relative;
          }
          .product_card_contents {
            background: #242424;
            color: #e4e4e4;
            width: 312px;
            border-radius: 4px 4px 0 0;
          }
          .product_title {
            font-family: big_noodle_titling;
            color: #e4e4e4;
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 24px;
          }
          .product_pricing {
            display: flex;
            flex-direction: column;
            background-color: #141414;
            padding: 30px;
            align-items: center;
            justify-content: center;
            width: 312px;
          }
          .product_pricing_total {
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: center;
          }
          .product_pricing_from {
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 13px;
            text-align: right;
          }
          .product_pricing_price {
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
          }
          .product_pricing_compare_price {
            color: #949494;
            font-family: 'Roboto-Light';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 13px;
            text-align: right;
            margin-left: 2%;
          }
          hr {
            background-color: #343434 !important;
          }
          .image-container {
            position: relative;
          }
          .image-sold-out {
            opacity: 0.4;
          }
          @media (max-width: ${breakPoints.medium}) {
            .product_card {
              margin: 0 auto;
              padding: 32px 0;
            }
          }
        `}
      </style>
    </div>
  );
};

ProductCardClearance.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
};

ProductCardClearance.defaultProps = {
  buttonLabel: 'START CUSTOMISING',
  fixedPrice: false,
};

export default ProductCardClearance;